import styled from 'styled-components';

export const ApplePayBtn = styled.button`
  height: 44px;
  width: 100%;
  border: none;
  border-radius: 8px;
  background: #000;
  color: #fff;

  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
  Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;

  transition: all 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active {
    opacity: 0.7;
    transform: scale(0.98);
  }
`;

